import apiClient from './client'
import type { Organization, OrganizationMember, OrganizationStats } from '@/types'

export const organizationsApi = {
  getMyOrganizations: async (): Promise<Organization[]> => {
    const { data } = await apiClient.get('/users/me/organizations')
    return data
  },

  getById: async (orgId: string): Promise<Organization> => {
    const { data } = await apiClient.get(`/organizations/${orgId}`)
    return data
  },

  getStats: async (orgId: string): Promise<OrganizationStats> => {
    const { data } = await apiClient.get(`/organizations/${orgId}/stats`)
    return data
  },

  getMembers: async (orgId: string): Promise<OrganizationMember[]> => {
    const { data } = await apiClient.get(`/organizations/${orgId}/members`)
    return data
  },
}
